<header class="profile-header">
  <div class="profile-header__brand">
    <span class="profile-header__brand-icon" aria-hidden="true"></span>
    <span class="profile-header__brand-logo">ROGERS</span>
    <span class="profile-header__brand-title">Profile management</span>
  </div>
  <button
    type="button"
    class="profile-header__hamburger"
    [class.profile-header__hamburger--open]="profileNavState.mobileNavOpen$ | async"
    [attr.aria-expanded]="profileNavState.mobileNavOpen$ | async"
    aria-label="Toggle menu"
    (click)="toggleMenu()">
    <span></span>
    <span></span>
    <span></span>
  </button>
</header>
